import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class Slider {
    constructor() {
        const swiper = new Swiper('.hero-swiper', {
            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            },
            speed: 2000,
            slidesPerView: 1,
            loop: true,
        });
    }
}